import { render, staticRenderFns } from "./auth-header.vue?vue&type=template&id=5cd0f9dc&scoped=true"
import script from "./auth-header.vue?vue&type=script&lang=ts"
export * from "./auth-header.vue?vue&type=script&lang=ts"
import style0 from "./auth-header.vue?vue&type=style&index=0&id=5cd0f9dc&prod&lang=scss&scoped=true"
import style1 from "./auth-header.vue?vue&type=style&index=1&id=5cd0f9dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd0f9dc",
  null
  
)

export default component.exports